import React, { FC, useEffect, useState, useCallback } from 'react';
import { compose } from 'redux';
import { BemMethod, createBem } from '@om-fe/utils';
import { BetslipPreBetSingleModel } from '@om-fe/widgets/dist/widgets/betslip/models/betslip-pre-bet-single-model';  
import { Odd } from '@om-fe/widgets/dist/components/odd/odd';
import { withSelectionBetslipData, WithSelectionBetslipDataModel } from '@om-fe/widgets/dist/widgets/betslip/with-betslip-selection-data/with-betslip-selection-data';
import { GeneralIcon } from '@om-fe/widgets/dist/components/icon/general-icon';
import {
    listenToMessage,
    ReceivedMessageType,
    sendMessage,
    SendMessageType,
} from '@om-fe/core/utils/parent-communication';

const bem: BemMethod = createBem({name: 'BetslipBubble'});

type BetslipBubblePublicProps = React.HTMLAttributes<HTMLElement>;

type BetslipBubbleProps = BetslipBubblePublicProps & WithSelectionBetslipDataModel;

const BetslipBubbleComponent: FC<BetslipBubbleProps> = ({ selectionList, preBet }: BetslipBubbleProps) => {
    const [totalOdds, setTotalOdds] = useState<number>(0);
    const [openBetslip, setOpenBetslip] = useState<boolean>(false);

    const handleOpenBetslip = useCallback(() => {
        sendMessage({ type: 'OP:showBetslip' as SendMessageType, isInternal: true });
        setOpenBetslip(true);
    }, []);

    useEffect(() => {
        const hideBetslipUnsubscribe = listenToMessage('OMFE:hideBetslip' as ReceivedMessageType, () => {
            setOpenBetslip(false);
        });

        return () => {
            hideBetslipUnsubscribe();
        };
    }, [setOpenBetslip]);

    useEffect(() => {
        setTotalOdds(0);
        if (preBet) {
            const singlePrebet: BetslipPreBetSingleModel[] = preBet.single ? Object.values(preBet.single) : [];
            if (selectionList.length === 1 && singlePrebet.length === 1 && singlePrebet[0].bettingOptions?.priceValueFactor) {
                return setTotalOdds(singlePrebet[0].bettingOptions?.priceValueFactor);
            } else if (preBet.multi.bettingOptions?.priceValueFactor) {
                return setTotalOdds(preBet.multi.bettingOptions.priceValueFactor);
            }
        }
    }, [selectionList, preBet]);

    return (
        <div className={bem({ modifiers: { IsBetslipOpen: !!openBetslip } })} onClick={handleOpenBetslip}>
            {selectionList.length
                ? 
                    <div className={bem('Wrapper')}>
                        <div className={bem('BetslipSelectionCount')}>
                            {selectionList.length}
                        </div>
                        <div className={bem('BetslipTotalOdds')}>
                            {totalOdds > 0
                                ? <Odd value={totalOdds} />
                                : <GeneralIcon name="betslip" />
                            }
                        </div>
                    </div>
                : <GeneralIcon name="betslip" />
            }
        </div>
    );
};

const BetslipBubble: FC<BetslipBubblePublicProps> = compose(
    withSelectionBetslipData<BetslipBubblePublicProps>()
)(BetslipBubbleComponent);
export default BetslipBubble;
